// index.ts — entry point for the item-arr-readers bundle (Wave 2c of plans/bundler-script-load-order-phase2.md).
// Vanilla-JS readers for the bucket-reshaped $item_arr / caster blob (ftLayerValue / ftLayerEntries /
// ftComputedValue / ftPicturesOf / ftItemsCol / … the front-end mirrors of the PHP bucket readers), carved
// out of template.js. item-arr-readers.ts attaches EVERY top-level declaration to window at eval (exhaustive
// — the classic-script auto-attach trap); this entry pulls it in. STAGED, not yet footer-swapped: pending
// real-browser global-parity verification (see the OPUS_REVIEW_QUEUE handoff). Loaded right after
// core-helpers, before every bundle + template.js, once wired.

import './item-arr-readers';
import { campsiteDefinitionAssets, campsiteShape, campsiteFloorBand } from '../janus-engine/campsite-scene-inputs';
Object.assign(window, { ftCampsiteDefinitionAssets: campsiteDefinitionAssets, ftCampsiteShape: campsiteShape, ftCampsiteFloorBand: campsiteFloorBand });
